// extracted by mini-css-extract-plugin
export default {"pageLoader":"PageLoader_pageLoader__gyOuI","loading":"PageLoader_loading__4bh+e"};